import { GerenciarDoisFA } from "../../components/GerenciarDoisFA";
import { TrocarMinhaSenha } from "../../components/TrocarMinhaSenha";
import { atlas } from "../../lib/sdk";

/** Minha conta — banco e operador do banco. */
export function BancoConta() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, maxWidth: 720 }}>
      <header>
        <span className="eyebrow">Consignatária</span>
        <h1 style={{ margin: "4px 0 0", fontSize: "1.8rem" }}>Minha conta</h1>
        <p style={{ color: "var(--text-muted)", marginTop: 6 }}>
          Gerencie a segurança do seu login.
        </p>
      </header>
      {/* Atende os dois logins do portal — o do banco e o do operador. Quem
          decide qual e' o servidor, pelo `banco_usuario_id` do token. Minimo 8,
          e nao 6: e' o que o zod de `/v1/portal/banco/conta/senha` exige. */}
      <TrocarMinhaSenha
        trocar={(atual, nova) => atlas.banco.trocarMinhaSenha(atual, nova)}
        minimo={8}
      />
      <GerenciarDoisFA />
    </div>
  );
}
